<template>
  <div>
    
    <section class="hero is-white">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="title is-4">
          後で読むアプリとして
        </p>
        <p class="subtitle">
          SafariやTwitterから
        </p>
        <p class="subtitle subtitle-detail has-text-">
          後で読みたい記事をLeitaに保存。<br>
          アプリやPCで管理できます。<br>
        </p>
        <img src="../../assets/tutorial4_1.gif" width="350px">
      </div>
    </section>

    <section class="hero is-white">
      <div class="hero-body has-text-centered" style="padding-bottom: 0">
        <p class="subtitle">
          設定方法
        </p>
        <img src="../../assets/tutorial4_2.gif" width="350px">
      </div>
    </section>
    <section class="hero" style="margin-top:150px">
      <div class="hero-body has-text-center" style="padding-bottom: 0; padding-right:105px">
        <img src="../../assets/arrow3.png" width="100px" height="100px">
      </div>
    </section>

  </div>
</template>

<script>
export default {
    name: 'ios',
    mounted() {
		document.title = "4.後で読むアプリとしての使い方"
	},
};
</script>

<style lang="scss" scoped>
.is-white {
    background-color:#fcfcfc !important;
}

.title, .subtitle {
  letter-spacing: 0.1em;
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Yu Gothic", YuGothic, Verdana, Meiryo, "M+ 1p", sans-serif;
}

.title {
 opacity: 0.85;
}

.hero-body {
  padding-left:12px;
  padding-right:12px;
}

.subtitle-detail {
    font-size: 0.9rem;
}
</style>

